// app/javascript/controllers/clipboard_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        text: String,
        targetId: String,
        copiedLabel: { type: String, default: "Copied!" },
        restoreLabel: String,
        toast: { type: Boolean, default: true },
        toastMessage: { type: String, default: "Link copied!" }
    }

    connect() {
        // If attached to a button, cache its label; if attached to wrapper, we’ll cache per-click
        this._originalLabel = this.restoreLabelValue || this.element.textContent?.trim()
    }

    copy(e) {
        e?.preventDefault()
        const btn = e?.currentTarget // <-- only touch the clicked button
        if (!btn) return

        // Prefer per-button data, then value, then targetId
        const explicit = btn.dataset.clipboardText || this.textValue
        const fromTarget = this.targetIdValue &&
            (document.getElementById(this.targetIdValue)?.value ?? null)
        const text = explicit || fromTarget
        if (!text) return

        const afterCopy = () => {
            // Cache & swap button HTML (so icons restore correctly)
            if (!btn._originalHTML) btn._originalHTML = btn.innerHTML
            const copied = btn.dataset.clipboardCopiedLabel || this.copiedLabelValue || "Copied!"
            btn.innerHTML = `<i class="bi bi-check-lg me-1"></i>${copied}`
            setTimeout(() => { if (btn._originalHTML) btn.innerHTML = btn._originalHTML }, 1500)
            if (this.toastValue !== false) this._toast()
        }

        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(text).then(afterCopy)
        } else {
            const ta = document.createElement("textarea")
            ta.value = text
            ta.style.position = "fixed"; ta.style.left = "-9999px"
            document.body.appendChild(ta); ta.select()
            try { document.execCommand("copy") } catch (_) {}
            document.body.removeChild(ta)
            afterCopy()
        }
    }

    _toast() {
        const hook = document.createElement("div")
        hook.dataset.controller = "swal"
        hook.dataset.swalIconValue = "success"
        hook.dataset.swalTitleValue = this.toastMessageValue
        hook.dataset.swalTimerValue = "3000"
        hook.dataset.swalPositionValue = "bottom-end"
        document.body.appendChild(hook)
        setTimeout(() => hook.remove(), 3500)
    }
}